export default __webpack_public_path__ + "b5d7484f1f6351a3b0d7aed4cc45c8d0.svg";